'use client';
import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem('cookieConsent');
      if (!accepted) {
        const timer = setTimeout(() => setVisible(true), 3000);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage not available
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem('cookieConsent', 'accepted');
    } catch {
      // localStorage not available
    }
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem('cookieConsent', 'declined');
    } catch {
      // localStorage not available
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-navy-dark border-t-2 border-gold shadow-luxury animate-fade-up">
      <div className="container-luxury py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="font-sans text-sm text-white/90">
              <span className="font-bold text-gold">We use cookies</span> to enhance your browsing
              experience and analyze our traffic. By continuing to use our website, you consent to
              our use of cookies in accordance with our{' '}
              <button className="text-gold underline hover:no-underline">Privacy Policy</button>.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={decline}
              className="font-sans text-xs font-bold uppercase tracking-wider px-5 py-2.5 border border-white/30 text-white/70 hover:border-white hover:text-white transition-colors duration-200"
            >
              Decline
            </button>
            <button
              onClick={accept}
              className="btn-gold text-xs px-5 py-2.5"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
